<template>
  <div class="confirm-content-block">
    <div class="confirm">
      <b-row>
        <b-col
          v-if="is_cancelled"
          md="9"
          offset-md="2"
          class="text-center mb-5 semibold"
        >
          <b-alert
            show
            :variant="'danger'"
          >
            Questa prenotazione è stata cancellata e pertanto non più valida.
          </b-alert>
        </b-col>
        <template v-for="(block,key) in confirm_blocks">
          <component
            v-if="block.show"
            v-bind:key="_uid+block+key"
            :is="block.key"
            :double_checked="is_double_checked"
            :confirm="confirm"
            :solution="confirm.epsVoucher.solution"
          />
          <!-- dopo il thankyou: conferma dell'orario di check-in da parte del cliente (indipendente dal double check) -->
          <b-col
            v-if="block.key === 'thankyou' && confirm.epsVoucher"
            :key="_uid + 'checkin-check' + key"
            md="12"
          >
            <checkin-check
              :checkin_check="confirm.epsVoucher.checkinCheck"
              :params="{
                confirmcode: confirm.epsVoucher.confirmcode,
                itinerary_id: confirm.epsVoucher.itinerary_id,
              }"
            />
          </b-col>
        </template>
      </b-row>
    </div>
  </div>
</template>

<script>
import ThankYou from '@liveeps/components/blocks/confirm/thankyou'
import CodesReferences from '@liveeps/components/blocks/confirm/codes-references'
import Reservation from '@liveeps/components/blocks/reservation'
import Hotel from '@liveeps/components/blocks/hotel'
import Accommodations from '@liveeps/components/blocks/accommodations'
import Informations from "@liveeps/components/blocks/informations"
import CancellationPolicy from '@liveeps/components/blocks/confirm/cancellation-policy'
import CheckinCheck from '@components/blocks/checkin-check'

export default {
  name: 'confirm-content-block',

  components: {
    'thankyou': ThankYou,
    'codes-references': CodesReferences,
    'reservation': Reservation,
    'hotel': Hotel,
    'accommodations': Accommodations,
    'cancellation-policy': CancellationPolicy,
    'informations': Informations,
    'checkin-check': CheckinCheck,
  },

  props: {
    confirm: Object, 
  },

  data() {
    return {
      confirm_blocks: [],
    }
  },

  computed: {

    is_double_checked() {
      return this.is_voucher_status('booked') && this.confirm.doubleCheck.confirmed
    },

    is_cancelled() {
      return this.is_voucher_status('cancelled')
    },
  },

  created() {
  },

  mounted() {
    this.confirm_blocks = [
      {
        key: "thankyou",
        show: true,
      },
      {
        key: "hotel",
        show: true,
      },
      {
        key: "reservation",
        show: true,
      },
      {
        key: "codes-references",
        show: true,
      },
      {
        key: "accommodations",
        show: true,
      },
      {
        key: "cancellation-policy",
        show: true,
      },
      {
        key: "informations",
        show: true,
      },
    ]
  },

  methods: {

    is_voucher_status(status) {
      return this.confirm.epsVoucher && this.confirm.epsVoucher.status === status
    },
  },
}
</script>

<style lang="scss" scoped>
</style>